// extracted by mini-css-extract-plugin
module.exports = {"modal":"ProductCatalogModal_modal__1D5DG","buttonContainer":"ProductCatalogModal_buttonContainer__3-DOd"};